import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import TagManager from "react-gtm-module";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import Services from './pages/Services';
import ScheduleAppointment from './pages/ScheduleAppointment'
import './App.css';
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { HelmetProvider } from 'react-helmet-async';

const tagManagerArgs = {
  gtmId: "GTM-KJSFTTWD",
};

TagManager.initialize(tagManagerArgs);

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Router>
      <HelmetProvider>
        <ScrollToTop />
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-mi" element={<AboutMe />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/agenda" element={<ScheduleAppointment />} />
          </Routes>
        </div>
      </HelmetProvider>
    </Router>
  );
}

export default App;
